import { Paper, styled, TextField, InputBase } from "@mui/material";

export const StyledTextField = styled(TextField)({
  ".MuiInputBase-root": {
    border: "1px solid rgb(204, 204, 204)",
    borderRadius: "4px",
    paddingLeft: "0.5rem",
    minHeight: "2.5rem",
    // backgroundColor: 'rgb(255, 255, 255) !important',
  },
  ".MuiInputBase-root.Mui-focused": {
    border: "1px solid black",
  },
});
export const StyledTextFieldSmall = styled(TextField)({
  ".MuiInputBase-root": {
    border: "1px solid rgb(204, 204, 204)",
    borderRadius: "4px",
    paddingLeft: "0.5rem",
    // minHeight: "2.5rem",
    fontSize: "12px",
    // backgroundColor: 'rgb(255, 255, 255) !important',
  },
  ".MuiInputBase-root.Mui-focused": {
    border: "1px solid black",
  },
});

export const CustomPaper = (props) => {
  return (
    <Paper
      elevation={0}
      {...props}
      sx={{
        my: 1,
        border: "1px solid rgb(204, 204, 204)",
        fontFamily: "DM Sans !important",
      }}
    />
  );
};

export const StyledInput = styled(InputBase)({
  border: "none !important",
  "& .MuiInputBase-input": {
    border: "1px solid rgb(204, 204, 204)",
    borderRadius: "4px",
    paddingLeft: "0.5rem",
    padding: "0 32px 0 8px !important",
    height: "38px !important",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    '&[aria-expanded="true"]': {
      border: "1px solid black",
    },
    // minHeight: '2.5rem',
  },
  // '.MuiInputBase-root.Mui-focused': {
  //     border: '1px solid black',
  // }
});
